import type { ExperimentalSearch } from '@/features/agentic-insights/components/experimental/briefing-4/data/searchState';
import { ExperimentalInsightsPage } from '@/features/agentic-insights/components/experimental/briefing-4/ExperimentalInsightsPage';
import { DEFAULT_VARIANT_ID } from './defaultVariantId';

export {
  DEFAULT_VARIANT_ID,
  DEFAULT_VARIANT_PATH,
  defaultVariantSearchSchema,
} from './defaultVariantId';

interface DefaultVariantViewProps {
  loopId: number;
  org: string;
  search: ExperimentalSearch;
}

/**
 * Briefing #4, rendered as the default reading. Mounted at two addresses — the nav item's bare route
 * and `/experimental/briefing-4` (the variant picker's own shareable link, per the README) — through
 * this one component and nowhere else, so the two addresses can never quietly drift into two
 * implementations of "the default".
 *
 * Kept in its own module, separate from `defaultVariantId.ts`: this one pulls in
 * `ExperimentalInsightsPage` (and everything it imports, `VariantPicker` included via `RunsCog`),
 * so it must not be where `VariantPicker` gets `DEFAULT_VARIANT_ID` from — see that module's own
 * comment for why.
 */
export const DefaultVariantView = ({ loopId, org, search }: DefaultVariantViewProps) => (
  <ExperimentalInsightsPage
    loopId={loopId}
    org={org}
    search={search}
    variant={DEFAULT_VARIANT_ID}
  />
);
